import z from 'zod';
import { Currencies } from '../settings/tasa-schema';

const PaymentFieldSchema = z.object({
  name: z.string(),
  value: z.string(),
});

export const PaymentMethodSchema = z
  .object({
    id: z.string(),
    title: z.string(),
    type: z.enum(['cash', 'transfer', 'zelle', 'crypto', 'other']),
    // Moneda nativa del método (ej. Zelle es USD, Pago Móvil es BS)
    currency: Currencies.default('USD'),
    isActive: z.boolean().default(true),
    fields: z.array(PaymentFieldSchema).default([]),
  });

export const PaymentSnapshotSchema = z.object({
  // 1. EL MÉTODO "CONGELADO"
  // Guardamos todo el objeto para que si el dueño borra el método después,
  // la venta vieja siga sabiendo cómo se pagó.
  method: PaymentMethodSchema,

  // 2. LA MATEMÁTICA (Normalization Engine)
  // Reemplazamos amount_usd por el valor contable normalizado
  amount_accounting: z.number(),
  accounting_currency: Currencies.default('USD'),

  // Lo que se movió físicamente (Los 500 Bs o los 10$)
  amount_local: z.number(),

  // La tasa oficial (BCV) capturada en este preciso milisegundo
  exchange_rate: z.number(),

  // 3. RASTRO FÍSICO Y AUDITORÍA
  reference: z.string().nullable().optional(),

  // Quién tiene la plata en la mano (ID del Barbero o el Local)
  receivedById: z.string(),
  receiverType: z.enum(['business', 'professional']),

  at: z.any(), // Timestamp de Firestore
});

export type PaymentSnapshot = z.infer<typeof PaymentSnapshotSchema>;
